
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css'
import Forms from './components/Forms';







function App() {


  return (
  <div className='App'>
    <Forms/>


  

    
   
  </div>
   
  );
}

export default App;
